import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@rsos/components/capstone/base';
import { CONVERSATION_ENDED } from '@rsos/constants/chatStatuses';
import {
  deleteConversation,
  fetchAlertConversationStatus,
} from '@rsos/reduxDataStore/src/features/alerts/chatSlice';
import { RootState, useAppDispatch } from '../../app';
import { PRIVILEGED_CHAT_MARGIN } from '../AlertChatBox/AlertChatBox.styles';
import PrivilegedChatHeader from '../PrivilegedChatHeader';
import AlertPrivilegedChatbox from './AlertPrivilegedChatbox';

interface PrivilegedConversation {
  id: string;
  participants: { id: string | number; name?: string }[];
  status?: string;
}

interface PrivilegedChatProps {
  chatRef: React.RefObject<HTMLDivElement>;
  isChatBoxVisible: boolean;
  unreadAmount: number;
  privilegedConversation: PrivilegedConversation;
  onActionButtonClick: () => void;
  bottomPaneHeight: string;
  isUnread: boolean;
}

const PrivilegedChat = ({
  chatRef,
  isChatBoxVisible,
  unreadAmount,
  privilegedConversation,
  onActionButtonClick,
  bottomPaneHeight,
  isUnread,
}: PrivilegedChatProps) => {
  const dispatch = useAppDispatch();
  const currentOrgName = useSelector(
    (state: RootState) => state.sinatra.user.currentOrg?.name,
  );

  const handleEndChat = () => {
    dispatch(
      deleteConversation({
        orgName: currentOrgName,
        conversationID: privilegedConversation.id,
      }),
    );
  };

  useEffect(() => {
    dispatch(
      fetchAlertConversationStatus({
        orgName: currentOrgName,
        conversationID: privilegedConversation.id,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      mb={PRIVILEGED_CHAT_MARGIN}
      ref={chatRef}
      grow={isChatBoxVisible}
      border={unreadAmount > 0 ? '1px solid' : undefined}
      borderColor={unreadAmount > 0 ? 'lightDanger' : undefined}
      borderRadius="5px"
    >
      <PrivilegedChatHeader
        alertChatParticipants={privilegedConversation.participants}
        isChatBoxVisible={isChatBoxVisible}
        isUnread={isUnread}
        onActionButtonClick={onActionButtonClick}
        hasChatEnded={
          privilegedConversation?.status === CONVERSATION_ENDED ||
          !privilegedConversation?.status
        }
        onEndChat={handleEndChat}
        unreadAmount={unreadAmount}
      />
      <AlertPrivilegedChatbox
        chatBoxHeight={bottomPaneHeight}
        isChatBoxVisible={isChatBoxVisible}
        hasChatEnded={privilegedConversation?.status === CONVERSATION_ENDED}
      />
    </Box>
  );
};

export default PrivilegedChat;
